import {Button, Drawer, Form} from "antd";
import React from "react";
import {connect} from "react-redux";

import {TableComp} from "sz-react-utils";
import moment from "moment";
import Request from "../../request";
let dateFormat = localStorage.getItem('company-details')?JSON.parse(localStorage.getItem('company-details')).dateFormat:'DD.MM.YYYY';
@Form.create()
class RecentInvoiceSettingsComponent extends React.Component {
    state = {
        visible: true,
        loading: false,
        count: 1,
        invoices: [],
        pastInvoices: [],
    };
    onClose = () => {
        this.setState({
            visible: false,
        });

        setTimeout(() => {
            this.props.onClose();
        }, 400);
    };

    onClickDone = (text, record) => {
        this.setState({loading: false});
        let params = {};
        params.id = record.id;
        return new Promise(async () => {
            await Request.updateInvoiceStatus(params);
            this.table.current.state.data.forEach((e, id) => {
                if (e.id == text.id) {
                    this.table.current.state.data.splice(id, 1);
                }
            });
            this.setState({loading: true});
        });
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    //Color change, action button click, only show if true(new field in db), move API code in this file, dateType today issue,
    apiRequest = () => {
        return new Promise(async (resolve) => {
            let params = {};
            params.atLevel = ["Claim Desk"];
            params.nextInvoiceGeneration = true;
            let response = await Request.loadCounselling({
                ...params,
            });
            let invoiceGenerationDates = [];
            if (response.data == '' || response.data == undefined) {
                this.setState({visible: false});
            } else {
                response.data.forEach((item) => {
                    if (
                        item.nextInvoiceGenerationDates &&
                        item.nextInvoiceGenerationDates.length > 0
                    ) {
                        item.nextInvoiceGenerationDates.forEach((invoiceDate) => {
                            let newObj = {};
                            if (!invoiceDate.invoiceGenerated) {
                                newObj.generationDate = moment(invoiceDate.generationDate).format(
                                    dateFormat
                                );
                                newObj.studentId = item.id;
                                newObj.id = invoiceDate._id;
                                newObj.studentName = item.studentName;
                                newObj.dateType = moment(newObj.generationDate).isSame(moment(), 'day')
                                    ? "Today"
                                    : moment(newObj.generationDate).isBefore()
                                        ? "Overdue"
                                        : "Future";
                                invoiceGenerationDates.push(newObj);
                            }
                        });
                    }
                });
            }
            resolve({
                data: invoiceGenerationDates.filter(
                    (item) => item.dateType != "Future"
                ),
            });
        });
    };

    render() {
        const {
            form: {getFieldDecorator, getFieldValue},
        } = this.props;

        const columns = [
            {
                title: "Vision ID",
                key: "studentId",
                dataindex: "studentId",
                width: 70,
            },
            {
                title: "Student Name",
                key: "studentName",
                dataindex: "studentName",
                width: 70,
            },

            {
                title: "Generation Date",
                key: "generationDate",
                dataindex: "generationDate",
                width: 70,
            },

            {
                title: "Date Type",
                key: "dateType",
                dataindex: "dateType",
                width: 70,
            },
            {
                title: "Actions",
                width: 30,
                render: (text, record) => <div>
                    <Button target="_blank" href={`/account-desk?invId=${(record.id)}`} shap="circle" icon="edit"/>
                </div>,
            },
        ];

        return (
            <Drawer
                title={
                    <div>
                        Invoices to be generated{" "}
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}
            >
                <TableComp
                    columns={columns}
                    ref={this.table}
                    apiRequest={this.apiRequest}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 20,
                        pageSizeOptions: ["10", "20", "50", "100", "1000"],
                    }}
                />
            </Drawer>
        );
    }


}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecentInvoiceSettingsComponent);
